// extracted by mini-css-extract-plugin
export default {"main":"Main_main__OtOiB","main__message":"Main_main__message__H9Dvp","button":"Main_button__m4GCa","background":"Main_background__nL6vo"};